export enum ATHOriginOfTransactionEnum {
  'SABA' = 1,
  'Saambou',
  'QmAdmin',
  'MbEngine',
  'ABSA',
  'QmAdmin SDT',
  'CStar',
  'Post Office',
  'Service Point',
  'Message',
  'BankServ',
  'EDOS',
  'Pastel',
  'HQ Portal',
  'Net1'
}

export namespace ATHOriginOfTransactionEnum {
  export function values() {
    return Object.keys(ATHOriginOfTransactionEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
